"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var index_1 = require("../index");
var PettyCashResource = /** @class */ (function (_super) {
    tslib_1.__extends(PettyCashResource, _super);
    function PettyCashResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PettyCashResource.endpoint = '/pcs';
    PettyCashResource.MODEL_NAME = 'pettycash';
    return PettyCashResource;
}(index_1.BaseTransactionResource));
exports.default = PettyCashResource;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/pc/index.js
// module id = 3QU9
// module chunks = 0